import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from './AuthContext';
import { toast } from 'react-toastify';
import NotVerified from '../Components/NotVerified';

const ProtectedRoute = ({ children, requiredRole = null }) => {
  const { isAuthenticated, user, loading, isLoggingOut } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (loading) return;

    if (!isAuthenticated) {
      if (!isLoggingOut) {
        toast.error("Please login/signup to access this feature", { toastId: 'unauthorized' });
      }
      navigate("/", { replace: true, state: { from: location } });
      return;
    }

    if (requiredRole) {
      const allowedRoles = Array.isArray(requiredRole) ? requiredRole : [requiredRole];
      if (!allowedRoles.includes(user?.role)) {
        if (!isLoggingOut) {
          toast.error("Please login/signup to access this feature", { toastId: 'unauthorized' });
        }
        navigate("/", { replace: true });
        return;
      }
    }
  }, [loading, isAuthenticated, user, requiredRole, isLoggingOut, navigate, location]);

  // Show loading spinner while checking authentication
  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ height: '50vh' }}>
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  // Prevent rendering children if not authenticated or wrong role
  if (!isAuthenticated) return null;
  if (requiredRole) {
    const allowedRoles = Array.isArray(requiredRole) ? requiredRole : [requiredRole];
    if (!allowedRoles.includes(user?.role)) return null;
  }

  // // Check if organizer is verified (only for routes requiring organizer role)
  // if (requiredRole) {
  //   const allowedRoles = Array.isArray(requiredRole) ? requiredRole : [requiredRole];
  //   if (allowedRoles.includes('organizer') && user?.role === 'organizer' && !user?.is_verified) {
  //     return <NotVerified />;
  //   }
  // }

  return children;
};

export default ProtectedRoute;